import { VoteFAQ } from "../../../../src/components/vote-faq";
import * as React from 'react';
export default {
  VoteFAQ,
  React
};